import { AiOverlay } from 'src/components/AiOverlay';
import { ProfileModal } from 'src/components/CustomerCompanyProfile';
import { LinearModal } from 'src/components/DocLinear/LinearModal';
import { DocPreviewModal } from 'src/components/DocPreviewModal/DocPreviewModal';
import { EnableRoadmapModal } from 'src/components/EnableRoadmapModal';
import { FeedbackProductTour } from 'src/components/FeedbackProductTour';
import { InsightProductTour } from 'src/components/InsightProductTour';
import { LearningCenterModal } from 'src/components/LearningCenterModal';
import { LimitationModal } from 'src/components/LimitationModal';
import { NewVersionToaster } from 'src/components/NewVersionToaster';
import { OfflineWarning } from 'src/components/OfflineWarning';
import { OnboardingSlack } from 'src/components/OnboardingSlack';
import { SlackTourModal } from 'src/components/ProductTour/SlackTourModal';
import { QuoteModal } from 'src/components/QuotePage/QuoteModal';
import { ReleasesProductTour } from 'src/components/ReleasesProductTour';
import { RoadmapProductTour } from 'src/components/RoadmapProductTour';
import { RoadmapTemplatesModal } from 'src/components/RoadmapTemplatesModal';
import SettingsModal from 'src/components/SettingsModal/SettingsModal';
import { SlackSettingsModal } from 'src/components/SlackSettingsModal';
import { SourcesModal } from 'src/components/SourcesModal';
import { StateToasters } from 'src/components/StateToasters';
import { ZoomImage } from 'src/components/ZoomImage/ZoomImage';
import { isDevEnv } from 'src/utils/env.util';

import { useWorkspaceContext } from '../../contexts/workspaceContext';
import { DocAutomationNotify } from '../DocAutomationNotify';
import { IntegrationSyncModal } from '../IntegrationSyncModal';
import { LinearImportModal } from '../LinearImportModal';
import { MettingsModalInstalled } from '../MettingsModalInstalled';
import { UpgradeModal } from '../UpgradeModal';

export const AppGlobalDialogs = () => {
  const productId = useWorkspaceContext(ctx => ctx.productId);
  return (
    <>
      <DocAutomationNotify />
      <ReleasesProductTour />
      <FeedbackProductTour />
      <InsightProductTour />
      <RoadmapProductTour />
      <DocPreviewModal />
      <LimitationModal />
      <LearningCenterModal />
      <SlackTourModal />
      <OnboardingSlack />
      <StateToasters>
        <OfflineWarning />
        {!isDevEnv() && <NewVersionToaster />}
      </StateToasters>
      <SlackSettingsModal />
      <SourcesModal />
      <RoadmapTemplatesModal />
      <AiOverlay />
      <IntegrationSyncModal />
      <ZoomImage />
      <LinearImportModal />
      <LinearModal />
      <MettingsModalInstalled />
      <SettingsModal />
      <EnableRoadmapModal />
      <UpgradeModal productId={productId} />
      <ProfileModal />
      <QuoteModal />
    </>
  );
};
